import React, { useContext } from 'react';
import { ProductContext } from '../../ProductContext';

const FitAndDescriptionToggle = ({ shouldShowOnlyDescription }: { shouldShowOnlyDescription: boolean }) => {
  const { setFitAndDescriptionView } = useContext(ProductContext);

  return (
    <div className="d-flex justify-content-end">
      <span
        data-testid={`fit-description-toggle`}
        className="label-add small-p fit-description-trigger"
        role="button"
        onClick={() => {
          setFitAndDescriptionView(true);
        }}
      >
        {shouldShowOnlyDescription ? `Description` : `Fit & Description`}
      </span>
    </div>
  );
};

export default FitAndDescriptionToggle;
